<template>
  <div>
    <v-col cols="12">
      <v-data-table
        v-model="selected"
        :headers="headers"
        :items="listVPSs"
        item-key="instanceID"
        show-select
        class="elevation-1"
        @click="updateActions"
      >
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-row style="margin-top: 1em">
              <v-col cols="1" style="margin-top: 10px">
                <v-toolbar-title>AWS</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
              </v-col>
              <v-col cols="2" style="margin-top: 10px">
                <v-select
                  :items="listStates"
                  label="Action"
                  dense
                  outlined
                  v-model="selectedState"
                  @change="changeState"
                  v-if="
                    listVPSs.length > 0 &&
                    selected.length > 0 &&
                    roles.change_vps_status
                  "
                ></v-select>
              </v-col>
              <v-col cols="5"><v-spacer></v-spacer></v-col>
              <v-col cols="3" style="margin-top: 5px">
                <v-overflow-btn
                  class="left"
                  :items="listRegions"
                  label="Regions"
                  editable
                  :item-text="(obj) => obj.name"
                  :item-value="(obj) => obj.code"
                  dense
                  v-model="selectedRegions"
                  @keyup.enter="loadVPS"
                ></v-overflow-btn>
              </v-col>
              <v-col cols="1" style="margin-top: 10px">
                <v-btn color="primary" dark class="mb-2" @click="loadVPS"
                  >Search</v-btn
                >
              </v-col>
            </v-row>
          </v-toolbar>
        </template>
        <template v-slot:item.instanceName="props">
          <v-edit-dialog
            :return-value.sync="props.item.instanceName"
            @save="save(props.item)"
            @cancel="cancel"
            @open="open(props.item)"
            @close="close"
            v-if="roles.change_vps_name"
          >
            {{ props.item.instanceName }}
            <template v-slot:input>
              <v-text-field
                v-model="props.item.instanceName"
                :rules="[max256chars]"
                label="Edit"
                single-line
                counter
              ></v-text-field>
            </template>
          </v-edit-dialog>
          <div v-else>{{ props.item.instanceName }}</div>
        </template>
        <template v-slot:item.instanceType="{ item }">
          <v-menu
            v-model="item.showData"
            :close-on-content-click="false"
            :nudge-width="200"
            offset-x
            persistent
          >
            <template v-slot:activator="{ on, attrs }">
              <a
                v-bind="attrs"
                v-on="on"
                style="color: black; text-decoration: none"
              >
                {{ item.instanceType }}
              </a>
            </template>
            <v-card class="mx-auto" max-width="344" outlined>
              <v-list-item>
                <v-list-item-content>
                  <template
                    v-for="(value, key) in item.instanceTypeDetail"
                    style="text-align: left"
                  >
                    {{ key }}: {{ value }} <br :key="key" />
                  </template>
                </v-list-item-content>
              </v-list-item>
            </v-card>
          </v-menu>
        </template>
        <template v-slot:item.state="{ item }">
          <v-icon
            small
            class="mr-2"
            color="success"
            v-if="item.state == 'running'"
          >
            mdi-circle
          </v-icon>
          <v-icon
            small
            class="mr-2"
            color="orange"
            v-else-if="item.state == 'stopped'"
          >
            mdi-circle
          </v-icon>
          <v-icon
            small
            class="mr-2"
            color="red"
            v-else-if="item.state == 'terminate'"
          >
            mdi-circle
          </v-icon>
          <v-icon small class="mr-2" color="grey" v-else> mdi-circle </v-icon>
          {{ item.state }}
        </template>
        <template v-slot:item.Username> Administrator </template>
        <template v-slot:item.password="{ item }">
          <v-btn
            v-clipboard="item.password"
            @click="onCopy"
            v-if="roles.read_vps_password"
            >COPY PASSWORD</v-btn
          >
          <div v-else>*****</div>
        </template>
        <template v-slot:item.enableAutoStop="{ item }">
          <template v-if="roles.enable_auto_stop">
            <v-switch
              v-model="item.enableAutoStop"
              @change="changeStateSwitch(item)"
            ></v-switch>
          </template>
        </template>
      </v-data-table>
    </v-col>

    <v-snackbar v-model="snackbar">
      {{ informText }}

      <template v-slot:action="{ attrs }">
        <v-btn color="pink" text v-bind="attrs" @click="snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>

    <v-snackbar v-model="snack" :timeout="3000" :color="snackColor">
      {{ snackText }}

      <template v-slot:action="{ attrs }">
        <v-btn v-bind="attrs" text @click="snack = false"> Close </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>


<script>
import axios from "axios";
import moment from "moment-timezone";
//import Vue from "vue";
//import HTTP from "../http-common"
import Amplify, { Auth } from "aws-amplify";

Amplify.configure({
  Auth: {
    region: "ap-southeast-1",
    userPoolId: "ap-southeast-1_8vBdk5PAd",
    userPoolWebClientId: "51e572vhkn38k7tuvsdst697b1",
    mandatorySignIn: true,
  },
});

export default {
  name: "Tags",
  //new Vue({
  data: () => ({
    snackbar: false,
    loading: true,
    dialog: false,
    dropdown: [],
    AuthStr: "", //'Bearer '.concat(this.$cookies.get('token')),
    user: {
      _id: "",
      name: "",
    },
    headers: [
      {
        text: "Name",
        align: "start",
        value: "instanceName",
      },
      { text: "Type", value: "instanceType" },
      { text: "State", value: "state" },
      { text: "Status", value: "status" },
      { text: "IP", value: "publicIpAddress" },
      { text: "Username", value: "Username" },
      { text: "Password", value: "password" },
      { text: "Launch Time", value: "launchTime" },
      { text: "Enable Auto Stop", value: "enableAutoStop" },
    ],
    max256chars: (v) => v.length <= 256 || "Input too long!",
    snack: false,
    snackColor: "",
    snackText: "",
    tempName: "",
    vps: [],
    listRegions: [],
    listVPSs: [],
    editedIndex: -1,
    editedItem: {
      _id: "",
      tag_name: "",
    },
    defaultItem: {
      _id: "",
      tag_name: "",
    },
    selectedRegions: "",
    selectedState: "",
    selected: [],
    showBtn: null,
    listStates: [],
    informText: "",
    copiedText: "",
    roles: [],
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "New Item" : "Edit Item";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
      if (val == true && this.editedIndex == -1) {
        this.showBtn = null;
        this.validation();
      } else {
        this.showBtn = null;
        this.validation();
      }
    },

    selected() {
      this.updateActions();
    },

    listVPSs() {
      console.log("watch");
      this.changeShow();
    },
  },

  methods: {
    //edit dialog
    async save(item) {
      var data = {
        name: item.instanceName,
        region_code: this.selectedRegions,
        instance_ids: [item.instanceID],
      };
      var currentSession = await this.$root.$refs.App.currentSession(
        "vps-change-name"
      );
      //console.log("selectedRegions: ", this.selectedRegions);
      if (currentSession.accessToken) {
        await fetch(window.domain + "vps/change-name", {
          method: "POST",
          headers: { Authorization: currentSession.accessToken },
          body: JSON.stringify(data),
        })
          .then((response) => response.json())
          .then((data) => {
            console.log(data);
            if (data.error_message == "") {
              this.snack = true;
              this.snackColor = "success";
              this.snackText = "Data saved";
            } else {
              this.cancel(data.error_message);
              item.instanceName = this.tempName;
            }
          })
          .catch((error) => console.log(error));
      }
      this.tempName = "";
    },
    cancel(error) {
      this.snack = true;
      this.snackColor = "error";
      if (!error) this.snackText = "Canceled";
      else this.snackText = error;
    },
    open(item) {
      this.tempName = JSON.parse(JSON.stringify(item.instanceName));
      this.snack = true;
      this.snackColor = "info";
      this.snackText = "Dialog opened";
    },
    close() {
      console.log("Dialog closed");
    },

    //VPS
    async loadRegions() {
      this.loading = true;
      var currentSession = await this.$root.$refs.App.currentSession(
        "vps-loadRegions"
      );
      if (currentSession.accessToken) {
        axios
          .get(window.domain + "vps/regions", {
            headers: { Authorization: currentSession.accessToken },
          })
          .then((response) => {
            this.listRegions = response.data.data;
            console.log("response: ", response);
            var temp = 0;
            for (let i = 0; i < this.listRegions.length - 1; i++) {
              for (let j = 0; j < this.listRegions.length - 1 - i; j++) {
                if (this.listRegions[j].order > this.listRegions[j + 1].order) {
                  temp = this.listRegions[j];
                  this.listRegions[j] = this.listRegions[j + 1];
                  this.listRegions[j + 1] = temp;
                }
              }
            }

            this.loading = false;
          })
          .catch((error) => {
            console.log("error " + error);
          });
      } else {
        console.log(
          "currentSession vps-loadRegions-undefined: ",
          currentSession
        );
      }
    },

    async loadVPS() {
      this.loading = true;
      this.listVPSs = [];
      var currentSession = await this.$root.$refs.App.currentSession(
        "vps-loadVPS"
      );
      console.log("selectedRegions: ", this.selectedRegions);
      if (currentSession.accessToken) {
        axios
          .get(window.domain + "vps/" + this.selectedRegions, {
            headers: { Authorization: currentSession.accessToken },
          })
          .then((response) => {
            this.listVPSs = response.data.data;
            for (const i of this.listVPSs) {
              i["showData"] = false;
              i.enableAutoStop = i.enableAutoStop == "true" ? true : false;
              i.launchTime = moment(i.launchTime)
                .tz("America/Los_Angeles")
                .format("DD/MMM/YYYY - HH:mm:ss");
            }
            console.log(this.listVPSs);
            this.loading = false;
          })
          .catch((error) => {
            console.log("error " + error);
          });
      } else {
        console.log("currentSession vps-loadVPS-undefined: ", currentSession);
      }
    },

    changeShow() {
      console.log("Change");
      for (const i of this.listVPSs) {
        i["showData"] = false;
      }
    },

    updateActions() {
      this.listStates = [];
      for (const i of this.listVPSs) {
        i["showData"] = false;
      }
      var temp = new Set();
      for (const i of this.selected) {
        temp.add(i.state);
      }

      //listStates:['start','stop','reboot','terminate']

      var temp2 = Array.from(temp);
      console.log(temp2);
      if (temp2.length == 1) {
        if (temp2[0] == "running") {
          this.listStates = ["stop", "reboot", "terminate"];
        } else if (temp2[0] == "stopped") {
          this.listStates = ["start", "terminate"];
        }
      } else if (temp2.length > 1) {
        this.listStates = ["terminate"];
      }
    },

    async changeState() {
      var a = this.selectedState;
      var text =
        "This action will " +
        a.toUpperCase() +
        " all the selected items, are you sure to do this?";
      var r = confirm(text);

      if (r != false) {
        var item = {
          action: this.selectedState,
          region_code: this.selectedRegions,
          instance_ids: [],
        };

        for (const i of this.selected) {
          item.instance_ids.push(i.instanceID);
        }

        console.log(item);
        var currentSession = await this.$root.$refs.App.currentSession(
          "vps-changeState"
        );
        if (currentSession.accessToken) {
          await fetch(window.domain + "vps/change-state", {
            method: "POST",
            headers: { Authorization: currentSession.accessToken },
            body: JSON.stringify(item),
          })
            .then((response) => response.json())
            .then((data) => console.log(data))
            .catch((error) => console.log(error));
          // console.log(JSON.stringify(response));
          this.selected = [];
          this.selectedState = "";
          this.listStates = [];
          this.loadVPS();
        } else {
          console.log(
            "currentSession vps-changeState-undefined: ",
            currentSession
          );
        }
      } else {
        this.selected = [];
        this.selectedState = "";
        this.listStates = [];
      }
    },

    async changeStateSwitch(item) {
      const index = this.listVPSs.indexOf(item);
      this.listVPSs[index].enableAutoStop;
      var temp = true;
      if (this.listVPSs[index].enableAutoStop == true) {
        temp = "true";
      } else {
        temp = "false";
      }

      var dataItem = {
        auto_stop: temp,
        region_code: this.selectedRegions,
        instance_ids: [this.listVPSs[index].instanceID],
      };

      console.log(JSON.stringify(dataItem));
      var currentSession = await this.$root.$refs.App.currentSession(
        "vps-changeStateSwitch"
      );
      if (currentSession.accessToken) {
        await fetch(window.domain + "vps/auto-stop", {
          method: "POST",
          headers: { Authorization: currentSession.accessToken },
          body: JSON.stringify(dataItem),
        })
          .then((response) => response.json())
          .then((data) => console.log(data))
          .catch((error) => console.log(error));
      } else {
        console.log(
          "currentSession vps-changeStateSwitch-undefined: ",
          currentSession
        );
      }
    },

    check() {
      console.log(this.editedItem);
    },

    sleep(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },

    async onCopy() {
      this.snackbar = true;
      this.informText = "Password was copied successful";
      await this.sleep(3000);
      this.informText = "";
      this.snackbar = false;
    },

    validation() {
      if (this.editedItem.tag_name != "") {
        this.showBtn = true;
      } else {
        this.showBtn = false;
      }
    },

    checkRoles(str) {
      var a = this.$root.$refs.App.hashCode(str);

      if (this.$cookies.get("roles") != null) {
        var role = this.$cookies.get("roles").split(",");
        var index = role.indexOf(a.toString());
        if (index != -1) return true;
        else return false;
      } else return false;
    },
  },

  async mounted() {
    this.roles = await this.$cookies.get("vps");
    if (this.roles.list_vps) {
      console.log("OK");
    } else {
      this.$router.push("/not-authorized");
    }

    try {
      await Auth.currentAuthenticatedUser({ bypassCache: false });
      this.loadRegions();
    } catch (error) {
      console.log("User logged out!");
      this.$router.push("/login");
    }
  },
};
</script>
